<template>
    <div>
        <slot
            :create="create"
            :loading="loading"
        />
    </div>
</template>

<script lang="ts">
import _template from 'lodash/template';
import Vue from "vue";
import Component from 'vue-class-component'
import axios from 'axios';

const LeadCreateProps = Vue.extend({
    props: {
        country: {
            type: String,
            required: true
        },
        language: {
            type: String,
            required: true
        },
        baseUrl: {
            type: String,
            required: true
        },
        campaignName: {
            type: String,
            required: true
        },
        utm: {
            type: Object,
            required: true
        },
        utmSource: {
            type: String,
            default: ''
        }
    }
})

type formData = {
    firstName: string
    lastName: string
    email: string
    phoneNumber: string
    company: string
    quantity: number
    fleetSize: string
    terms: boolean
}

@Component
export default class LeadCreate extends LeadCreateProps {
    public loading = false;

    create(form:formData) {
        const {company, quantity, fleetSize, terms, ...customer} = form;
        this.loading = true;
        axios({
            method: 'POST',
            url: `/cod/api/leads`,
            baseURL: this.baseUrl,
            params: {
                language: this.language,
                country: this.country,
                ...(this.utm || {}),
            },
            data: {
                customer: {
                    ...customer,
                    language: this.language,
                    country: this.country,
                },
                additionalData: {
                    email_subscribe: terms ? 'subscribed' : 'unsubscribed',
                    company_name: company,
                    quantity_requested: quantity,
                    fleet_size: fleetSize
                },
                campaign: {
                    name: _template(this.campaignName, { interpolate: /{{([\s\S]+?)}}/g })({ country: this.country }),
                    params: {
                        note: `Company name: ${company}; Fleet size: ${fleetSize}; Quantity requested: ${quantity}`
                    }
                },
                operatingSystem : {
                    name: 'pipedrive'
                }
            },
        }).finally(() => {
            this.loading = false;
            this.$emit('submitted');
        })
    }
}
</script>
